import { useEffect } from "react";
import Page from "../components/Page";

const TermCookiePage = () => {

    useEffect(() => {
        if (document.getElementById("id_page_404") !== null) {
            document.getElementById("id_page_404").style.display = "none";
        }
    }, [])

    return (
        <>
            <Page>

            <section className="mymoney chatbox pb-5 cacoh">
    <div className="dasdfboxti mock">
        <div className="titlexbxc container">
            <div className="row">
                <div className="col-md-12">
                    <h3>Cookie Policy</h3>
                </div>
            </div>
        </div>
    </div>
    <div className="container  pt-5">
        <div className="row">
            <div className="col-md-12">
                <div className="coach-section w-100 d-block">
                    <div className=" text-center">
                        <div className="term-icon mb-3 text-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="120" height="120" fill="var(--footer-color, #415385)"><path d="M5.32943 3.27158C6.56252 2.8332 7.9923 3.10749 8.97927 4.09446C9.96652 5.08171 10.2407 6.51202 9.80178 7.74535L20.6465 18.5902L18.5252 20.7115L7.67936 9.86709C6.44627 10.3055 5.01649 10.0312 4.02952 9.04421C3.04227 8.05696 2.7681 6.62665 3.20701 5.39332L5.44373 7.63C6.02952 8.21578 6.97927 8.21578 7.56505 7.63C8.15084 7.04421 8.15084 6.09446 7.56505 5.50868L5.32943 3.27158ZM15.6968 5.15512L18.8788 3.38736L20.293 4.80157L18.5252 7.98355L16.7574 8.3371L14.6361 10.4584L13.2219 9.04421L15.3432 6.92289L15.6968 5.15512ZM8.62572 12.9333L10.747 15.0546L5.79729 20.0044C5.2115 20.5902 4.26175 20.5902 3.67597 20.0044C3.12464 19.453 3.09221 18.5793 3.57867 17.99L3.67597 17.883L8.62572 12.9333Z"></path></svg>
                        </div>
                        <h1 className="text-center">Under Construction</h1>
                        
                </div>
            </div>
            

            </div>
        </div>
    </div>
</section>



              
            </Page>
        </>
    );
}

export default TermCookiePage;